import Axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import { toastError } from '@/lib/toast';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/react';

export const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axios.defaults.xsrfCookieName = process.env.REACT_APP_COOKIE_CSRF_TOKEN_NAME;
axios.defaults.xsrfHeaderName = 'X-CSRF-Token';
axios.defaults.withCredentials = true;

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = Cookies.get(process.env.REACT_APP_COOKIE_CSRF_TOKEN_NAME!);
  if (token) {
    config.headers['X-CSRF-Token'] = token;
  }

  if (config.headers) {
    config.headers.Accept = 'application/json';
  }

  return config;
}

axios.interceptors.request.use(authRequestInterceptor);

axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.errors?.join(',') || error.message;
    // console.log(`[API ERROR] status: ${error.response?.status}, message: ${message}`);

    const statusCode = error.response?.status;

    Sentry.captureException(error);

    // if (statusCode !== 422 && statusCode !== 404) {
    //   toastError(message);
    // }

    return Promise.reject(error);
  }
);

export default axios;
